{
  "language-selection-dialog": {
    "buttons": {
      "close": "Schließen"
    },
    "text": {
      "title": "Sprachauswahl",
      "hint": "Wählen Sie die anzuzeigende Sprache aus"
    }
  }
}
